export default "__VITE_ASSET__DAShypPo__"